
import Vue from 'vue'
import CurrencyRateItem from './currency-rate-item.vue'

export default Vue.extend({
  components: {
    CurrencyRateItem
  },
  props: {
    point: {
      type: Object,
      required: true,
      default: () => { return {} }
    }
  },
  computed: {
    currencyInfo () {
      return this.point?.currency?.currenciesInfo?.slice()?.sort(
        (currency1: { sign: string }, currency2: { sign: string }) => {
          return currency2?.sign?.localeCompare(currency1?.sign)
        }
      )
    }
  }
})
